module.exports = __webpack_public_path__ + "img/clip_01.f74e94e0.svg";